import { createAction } from '@reduxjs/toolkit';
import type { PopupState } from 'src/routes/SearchPage/store/map/types';
import {
  FETCH_HOTEL_DATA,
  HOTEL_DATA_FETCHED,
  RESET_POPUP_DATA,
  SET_POPUP_DATA,
  TOGGLE_MAP,
} from './constants';

export const toggleMap = () => ({
  type: TOGGLE_MAP,
});

export const fetchHotelDataActions = (payload) => ({
  type: FETCH_HOTEL_DATA,
  payload,
});

export const hotelDataFetched = (payload) => ({
  type: HOTEL_DATA_FETCHED,
  payload,
});

export const setPopupData =
  createAction<Omit<PopupState, 'hotelInfo'>>(SET_POPUP_DATA);

export const resetPopupData = createAction(RESET_POPUP_DATA);
